import './DashboardSkeleton.scss';

/**
 * DashboardSkeleton
 * Renders a shimmer placeholder that structurally exactly mirrors the real
 * Dashboard.tsx and ProfileCard.tsx DOM nodes, preventing layout jumps.
 */
export const DashboardSkeleton = () => {
    return (
        <div className="dash-skeleton">

            {/* Simulated Intro Div */}
            <div className="cco_row cco_row_4">
                <div className="cco_col">
                    <div className="cco_text cco_text_0">
                        <div className="cco_text_inner">
                            <div className="dash-skeleton-hello" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Simulated Profile Picture Card */}
            <div>
                <div className="cco_row cco_row_0">
                    <div className="cco_col cco_col_4">
                        <div className="dash-skeleton-avatar" style={{ margin: '0 24px' }} />
                    </div>
                    <div className="cco_col cco_col_12">
                        <div className="cco_text cco_text_1" style={{ fontWeight: '700' }}>
                            <div className="dash-skeleton-profile-info">
                                <div className="dash-skeleton-line dash-skeleton-line--name" />
                                <div className="dash-skeleton-line dash-skeleton-line--detail" style={{ marginTop: 12 }} />
                                <div className="dash-skeleton-line dash-skeleton-line--short" style={{ marginTop: 6 }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Action section border (mirrors cco_row cco_row_3 action-section-border) ── */}
            <div className="cco_row cco_row_3 action-section-border" style={{ marginTop: 24 }}>
                <div className="dash-cards-row">
                    {[1, 2, 3].map((card) => (
                        <div key={card} className="dash-card skeleton-card-mode" style={{ cursor: 'default' }}>
                            <div className="dash-card-icon">
                                <div className="dash-skeleton-icon-shimmer" />
                            </div>
                            <div className="dash-card-info">
                                <div className="dash-skeleton-line dash-skeleton-line--detail" />
                                <div className="dash-skeleton-line dash-skeleton-line--short" style={{ marginTop: 8 }} />
                            </div>
                        </div>
                    ))}
                </div>

                {/* ── Demo Exam button ── */}
                <div className="dash-demo-container">
                    <div className="dash-skeleton-demo-btn" />
                </div>
            </div>

            {/* ── My Certifications title row (mirrors cco_row cco_row_7) ── */}
            <div className="cco_row cco_row_7">
                <div className="cco_col cco_col_6">
                    <div className="cco_text cco_text_10">
                        <div className="cert-title-container">
                            <div className="dash-skeleton-cert-title" />
                            <div className="dash-skeleton-cert-actions">
                                <div className="dash-skeleton-cert-btn" />
                                <div className="dash-skeleton-cert-btn" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Cert cards (mirrors cco_row cco_row_3 > cco_group_myCredential) ── */}
            <div className="cco_row cco_row_3">
                <div className="cco_col">
                    <div className="cco_group cco_group_myCredential">
                        {[1, 2, 3].map((card) => (
                            <div key={card} className="cco_group_item tpCards">
                                <div className="cco_card cco_card_myCertification">
                                    <div className="cco_card_body">
                                        <div className="cco_card_aside">
                                            <div className="cco_img">
                                                <span className="cco_img_wrap">
                                                    <div className="dash-skeleton-cert-badge" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="cco_card_main" style={{ width: '100%', padding: '10px' }}>
                                            <div className="cco_text cco_text_myCredential">
                                                <div className="cco_text_inner">
                                                    <div className="dash-skeleton-line dash-skeleton-line--name" style={{ marginBottom: 8 }} />
                                                    <div className="dash-skeleton-line dash-skeleton-line--detail" style={{ marginBottom: 6 }} />
                                                    <div className="dash-skeleton-line dash-skeleton-line--short" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </div>
    );
};
